/* eslint-disable import/no-default-export */
export default {
  Forbidden: 'Proibito',
  Length: 'La "{{label}}" è compreso tra un minimo di {{Min}} lettere e un massimo di {{Max}} lettere',
  LengthLong: 'La lunghezza massima è di {{max}} caratteri',
  LengthShort: 'Il numero minimo di caratteri è {{min}}',
  NoSpecialCharacters: 'Il "{{label}}" non può contenere caratteri speciali',
  NotEmpty: 'Il campo non può essere vuoto.',
  Required: 'Il campo "{{label}}" è obbligatorio',
  ServerError: 'Server error',
  Warning: 'Attenzione',
  ForbiddenText: 'Non sei autorizzato ad accedere a questa pagina.',
  MinMax: 'Il valore deve essere compreso tra {{min}} e {{max}}',
  NotEmail: 'Il valore non ha un formato email valido.',
  OnlyNumbersOrSpace: 'La {{Label}} può contenere solo numeri o spazio'
}
